module.exports = __webpack_public_path__ + "static/media/ic-chat.db5fe136.svg";